// extracted by mini-css-extract-plugin
export default {"widget":"LinkedTaskField_widget__YWORG"};